<template>
  <div class="VisualizarOrcamentos" style ="width: 1000px;">

    <el-row class="el-row-topo esconder_impressao">
      <el-col :span="22">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/termometria' }">Termometria</el-breadcrumb-item>
          <el-breadcrumb-item>Visualizar Orçamento Termometria</el-breadcrumb-item>
        </el-breadcrumb>
        <el-button @click="imprimir">Imprimir</el-button>
      </el-col>
    </el-row>

  <el-row>
    <h2>Orçamento Termometria</h2>
  </el-row>

  <el-row>
    <table>
      <tr>
        <td style="text-align: rigth;">Cliente:</td>
        <td colspan="3" style="text-align: left; width: 350px;"><b>{{orcamentoTermometriaCliente.nome}}</b></td>
        <td style="width: 250px;"></td>
        <td style="text-align: right; width: 110px;">Total s/ IPI:</td>
        <td style="text-align: right;"><b>{{orcamentoTermometriaCliente.subtotal}}</b></td>
        <td style="width: 20px;"></td>
        <td style="text-align: right;">Número:</td>
        <td style="text-align: left;"><b>{{orcamentoTermometriaCliente.id.toString().padStart(6, "0")}}</b></td>
      </tr>
      <tr>
        <td style="text-align: right;">Negócio:</td>
        <td style="text-align: left;"><b>{{orcamentoTermometriaCliente.numero_negocio}}</b></td>
        <td style="text-align: right;">Versão:</td>
        <td style="text-align: left;"><b>{{orcamentoTermometriaCliente.numero_versao}}</b></td>
        <td style="width: 250px;"></td>
        <td style="text-align: right;">IPI:</td>
        <td style="text-align: right;"><b>{{orcamentoTermometriaCliente.ipi}}</b></td>
      </tr>    
      <tr>
        <td style="text-align: right;">Cidade:</td>
        <td style="text-align: left;"><b>{{orcamentoTermometriaCliente.cidade}}</b></td>
        <td style="text-align: right;">Estado:</td>
        <td style="text-align: left;"><b>{{orcamentoTermometriaCliente.estado}}</b></td>
        <td style="width: 250px;"></td>
        <td style="text-align: right;">Total:</td>
        <td style="text-align: right;"><b>{{orcamentoTermometriaCliente.total}}</b></td>
      </tr>    
    </table>
  </el-row>
  <el-divider></el-divider>
  <el-row>
    <el-table
      :data="orcamentoTermometriaItens"
      style="width: 100%"
      stripe
      v-loading="loading"
      element-loading-text="Loading..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(255, 255, 255, 0.7)"
    >
      <el-table-column prop="descricao" label="Descrição" width="365"></el-table-column>
      <el-table-column prop="modelo" label="Modelo" width="130"></el-table-column>
      <el-table-column prop="cod_nbr" label="Cód NBR" width="85"></el-table-column>
      <el-table-column prop="cod_fornecedor" label="Cód Fornecedor" width="150"></el-table-column>
      <el-table-column prop="qtde" label="Qtde" width="70" align="right" header-align="right"></el-table-column>
      <el-table-column label="Unitário" width="100" align="right" header-align="right">
        <template v-slot="{ row }">
            <span>  {{formataDolarToReal(parseFloat(row.valor_unitario)) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Sub Total" width="100" align="right" header-align="right">
        <template v-slot="{ row }">
            <span>  {{formataDolarToReal(parseFloat(row.subtotal)) }}</span>
        </template>
      </el-table-column>
    </el-table>
  </el-row>
  <el-divider></el-divider>
  <el-row style="text-align: left;">
    <span><b>Nota:</b></span><br/>
    <span>1 – Definir o modelo do silo;</span><br/>
    <span>2 – Definir a quantidade de silos;</span><br/>
    <span>3 – Definir a quantidade de ventiladores (Se houver controle da aeração)</span><br/>
  </el-row>
  <br/>
  <el-row style="text-align: left;">
    <span><b>Observações:</b></span><br/>
    <span>1 – Valores sem mão de obra para instalação, caso necessário deverá ser cotado a parte;</span><br/>
    <span>2 – Frete na modalidade FOB-PANAMBI/RS;</span><br/>
    <span>A NBRtec se propõe a tratar e definir a Transportadora quando da necessidade de embarques, ficando o frete a pagar pelo(a) {{ orcamentoTermometriaCliente.nome }};</span><br/>
  </el-row>

  </div>
</template>
<script>

// const url = "http://" + window.location.hostname + ":8000/api";
const url = '/api';

import axios from "axios";

export default {
  components: {
  },

  data() {
    return {
      loading: false,
      labelPosition: "right",
      orcamentoTermometriaCliente: {
        nome: '',
        numero_negocio: 0,
        numero_versao: 0,
        cidade: '',
        estado: '',
        subtotal: 0,
        ipi: 0,
        total: 0,
      },
      orcamentoTermometriaItens: [],
    };
  },

  mounted() {

    if (this.$route.params.id) {

      axios
        .get(url + "/orcamentotermometria/" + this.$route.params.id, {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          },
        })
        .then((resp) => {
          if (resp.data.status == "Token is Expired" || resp.data.status == "Token is Invalid" || resp.data.status == "Authorization Token not found") {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.orcamentoTermometriaCliente.id = resp.data.id
            this.orcamentoTermometriaCliente.nome = resp.data.cliente
            this.orcamentoTermometriaCliente.numero_negocio = resp.data.num_negocio
            this.orcamentoTermometriaCliente.numero_versao = resp.data.versao
            this.orcamentoTermometriaCliente.cidade = resp.data.cidade
            this.orcamentoTermometriaCliente.estado = resp.data.estado
            this.orcamentoTermometriaCliente.subtotal = this.formataDolarToReal(parseFloat(resp.data.subtotal))
            this.orcamentoTermometriaCliente.ipi = this.formataDolarToReal(parseFloat(resp.data.ipi))
            this.orcamentoTermometriaCliente.total = this.formataDolarToReal(parseFloat(resp.data.total))
          }
        })
        .catch((err) => {
          this.$notify({
            title: "Erro",
            message:
              "Erro ao buscar os dados! Tente novamente mais tarde!" + err,
            type: "error",
          });
        });

      
      axios
        .get(url + "/termoitemlist/" + this.$route.params.id, {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          },
        })
        .then((resp) => {
          if (resp.data.status == "Token is Expired" || resp.data.status == "Token is Invalid" || resp.data.status == "Authorization Token not found") {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.orcamentoTermometriaItens = resp.data
          }
        })
        .catch((err) => {
          this.$notify({
            title: "Erro",
            message:
              "Erro ao buscar os dados! Tente novamente mais tarde!" + err,
            type: "error",
          });
        });
    }
   
  },
  methods:{
    imprimir(){
      print();
    },
    formataDolarToReal(valor,casasDecimais = 2) {
      if (isNaN(valor) || valor === null) return "0,00";
      let val = new String(valor.toFixed(casasDecimais));
      val = val.replace(",","");
      val = val.replace(".","");
      let tmp = val+'';
      tmp = tmp.replace(/([0-9]{2})$/g, ",$1");
      if( tmp.length > 6 )
          tmp = tmp.replace(/([0-9]{3}),([0-9]{2}$)/g, ".$1,$2");
      return tmp;
    },
  }
};
</script>

<style scoped>
.el-table thead {
  color: black !important;
}
.el-table {
  color: black !important;
}
</style>
